const enum JournalType {
    OFFLINE_JOURNAL = 1,
    SXS_JOURNAL,
    SXS_OBS,
    REMOTE_OBS,
}

const JournalTypeUrlMap = [
    '',
    '/Journal/Journal_Offline.aspx',
    '/Journal/Journal_SideXSide.aspx',
    '/Journal/Observation_SideBySide.aspx',
    '/Journal/Observation_Remote.aspx',
    '/Journal/Journal_Offline.aspx',
];

export function determineJournalUrl(type: number, id: number): string {
    let url;
    switch (type) {
        case JournalType.SXS_JOURNAL:
        case JournalType.SXS_OBS:
        case JournalType.REMOTE_OBS:
            url = JournalTypeUrlMap[type];
            break;
        default:
            url = JournalTypeUrlMap[JournalType.OFFLINE_JOURNAL];
    }
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${url}?JournalID=${id}`;
}
